export default "__VITE_ASSET__DbkOggUp__"